import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const JSM_REQUEST_TYPE_SETTINGS_CLIENT_ID: ClientId = client('jsm-request-type-settings');
